


















import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";

@Component({})
export default class Curtains extends Vue {
  cover = true;
  $refs!: {
    curtains: Element;
  };

  // Ссылки на глобальное состояние
  @State(state => state.app.loadingScreenActive) loadingScreenActive!: number;

  mounted() {
    this.showLines();
  }

  /** Количество шторок к отображению */
  get numberOfCurtains(): number {
    if (this.$browser.width > 900) return 5;
    else if (this.$browser.width > 400) return 4;
    else return 1;
  }

  /**
   *  Считает ширину для шторки с указанный номером
   * @returns {number} Ширина в пикселях
   * @param {number} index  Номер шторки
   * */
  calcWidthForSection(index: number): number {
    let widthForFirstAndLast = 220;
    if (this.$browser.width < 1200) widthForFirstAndLast = 80;
    if (this.$browser.width < 1020) widthForFirstAndLast = 35;
    if (this.$browser.width < 400) widthForFirstAndLast = window.innerWidth;

    let width = (this.$browser.width - widthForFirstAndLast * 2) / (this.numberOfCurtains - 2);
    if (index == 1 || index == this.numberOfCurtains) {
      return widthForFirstAndLast;
    }
    return width;
  }

  /**
   * Определяет позицию шторки по ее номеру
   * @returns {number} Отступ слева в пикселях
   * @param {number} index  Номер шторки
   * */
  calcLeftForSection(index: number): number {
    let left = 0;
    for (let q = 1; q < index; q++) {
      left += this.calcWidthForSection(q);
    }
    return left;
  }

  /**
   * Считает отсуп для внутреннего градиента шторки.
   * Необходимо для точного совпадения градиентов разных шторок.
   * @returns {number} Расстояние от правой грани экрана до правой грани шторки
   * @param {number} index Номер шторки
   * */
  calcRightForGradientBlock(index: number): number {
    return this.$browser.width - this.calcLeftForSection(index + 1);
  }

  // Запускаем анимацию закрытия шторок на исчезновении экрана загрузки
  @Watch("loadingScreenActive")
  onLoadingScreenHide() {
    this.openCurtains();
    setTimeout(() => {
      this.cover = false;
    }, 1500);
  }

  //*************************/
  // Анимации ****************
  //*************************/

  /**  Запускает анимацию скрытия шторок */
  openCurtains() {
    // Анимация шторок
    anime({
      targets: this.$refs.curtains.querySelectorAll(".curtain"),
      duration: 1000,
      width: ["100%", "0%"],
      delay: (el, i) => {
        return 120 * i;
      },
      complete: () => {
        this.$refs.curtains.classList.add("curtains-hidden");
      },
      easing: "easeInOutCubic"
    });
  }

  /**  Запускает анимацию появления линий между шторками */
  showLines() {
    let vlines = this.$refs.curtains.querySelectorAll(".line");
    vlines.forEach((line: Element, index: number) => {
      let innerLine = line.querySelector("div")!;
      anime({
        targets: line,
        height: ["0%", "100%"],
        easing: "easeOutQuint",
        duration: 1200,
        delay: 700 + 350 * index
      });
    });
  }
}
